import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AutofillMonitor } from '@angular/cdk/text-field';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'portal-text-control',
  templateUrl: './text-control.component.html',
  standalone: false,
})
export class TextControlComponent implements AfterViewInit, OnDestroy {
  @ViewChild('inputRef', { static: true }) inputRef!: ElementRef<HTMLInputElement>;
  @Input() name: string;
  @Input() control: UntypedFormControl;
  @Input() invalid: boolean;
  @Input() optional: boolean;
  @Input() e2eName = 'textControl-input';
  @Input() autoFocus = false;
  @Input() autocomplete: string = 'off';
  @Output('blur') controlBlurred = new EventEmitter<FocusEvent>();
  private autoFillSub?: Subscription;

  constructor(private autofill: AutofillMonitor) {}

  ngAfterViewInit(): void {
    const el = this.inputRef.nativeElement;
    if (this.autoFocus) {
      el.focus();
    }
    // Subscribe once: AutofillMonitor emits initial state immediately
    this.autoFillSub = this.autofill
      .monitor(el)
      .pipe(take(1))
      .subscribe((e) => {
        /* if autofill is detected do not focus on element and mark control pending
         for validation as it must be validated only on user action*/
        if (e.isAutofilled) {
          if (document.activeElement === el) {
            el.blur();
            this.control.markAsPending();
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.autoFillSub?.unsubscribe();
    this.autofill.stopMonitoring(this.inputRef.nativeElement);
  }

  onBlur(event: FocusEvent): void {
    this.controlBlurred.emit(event);
  }

  /* Function to expose native ref to parent */
  get nativeInput(): HTMLInputElement {
    return this.inputRef.nativeElement;
  }
}
